import Link from "next/link";
import { Search, Menu } from "lucide-react";
import { ThemeToggle } from "../theme-toggle";
import { MobileMenu } from "../mobile-menu";

const NAV_ITEMS = [
  { label: "Trang chủ", href: "/" },
  { label: "Crypto", href: "/category/crypto" },
  { label: "Chứng khoán", href: "/category/chung-khoan" },
  { label: "Vàng", href: "/category/vang" },
  { label: "Phân tích", href: "/category/phan-tich" },
  { label: "Tin nóng", href: "/category/tin-nong" },
];

/**
 * V2 "Magazine" Header — minimalist, no ticker, big serif logo,
 * inline nav with hairline below. Sticky on scroll with backdrop blur.
 */
export function HeaderV2() {
  return (
    <header
      className="sticky top-0 z-40 border-b"
      style={{
        background: "color-mix(in oklch, var(--paper) 92%, transparent)",
        backdropFilter: "blur(18px) saturate(140%)",
        WebkitBackdropFilter: "blur(18px) saturate(140%)",
        borderColor: "color-mix(in oklch, var(--line) 60%, transparent)",
      }}
    >
      <div className="mx-auto max-w-[var(--container-content)] px-6 lg:px-10">
        <div className="flex items-center justify-between gap-6 h-16 lg:h-20">
          {/* Mobile menu */}
          <span className="lg:hidden">
            <MobileMenu items={NAV_ITEMS} />
          </span>

          {/* Logo */}
          <Link
            href="/"
            className="font-[family-name:var(--font-fraunces)] text-2xl lg:text-3xl tracking-tight font-medium"
            style={{
              color: "var(--ink)",
              fontVariationSettings: "'opsz' 144, 'SOFT' 30",
            }}
            aria-label="Finzone"
          >
            Finzone
          </Link>

          {/* Inline nav */}
          <nav
            className="hidden lg:flex items-center gap-7 text-[13px] font-medium tracking-wide"
            style={{ color: "var(--ink-2)" }}
          >
            {NAV_ITEMS.slice(1).map((it) => (
              <Link
                key={it.href}
                href={it.href}
                className="relative py-2 hover:text-[var(--accent)] transition-colors after:content-[''] after:absolute after:bottom-1 after:left-0 after:right-0 after:h-px after:bg-[var(--accent)] after:scale-x-0 hover:after:scale-x-100 after:origin-left after:transition-transform"
              >
                {it.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              href="/tim-kiem"
              aria-label="Tìm kiếm"
              className="inline-flex items-center justify-center w-9 h-9 rounded-full hover:bg-[var(--bg-2)] transition"
              style={{ color: "var(--ink-2)" }}
            >
              <Search size={16} />
            </Link>
            <span className="hidden sm:block">
              <ThemeToggle />
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
